import React from 'react';

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  name: string;
  value: string;
  label: React.ReactNode;
  /**
   * Klassen voor het omhullende <label>. Zonder dit is een radio altijd een
   * inline regeltje; met `w-full` erin wordt hij een aanklikbare rij of kaart.
   * Combineert met `has-[:checked]:` om die rij zelf te markeren.
   */
  wrapperClassName?: string;
  /** Klassen voor de tekst-span naast de knop, bv. `min-w-0 flex-1` in een rij. */
  labelClassName?: string;
}

const Radio: React.FC<RadioProps> = ({
  name,
  value,
  label,
  className = '',
  wrapperClassName = 'inline-flex items-center gap-2 text-sm text-pt-forest',
  labelClassName = '',
  id,
  ...rest
}) => (
  <label
    htmlFor={id}
    className={`cursor-pointer select-none ${wrapperClassName} ${rest.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
  >
    <span className="relative inline-flex shrink-0">
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        className={`peer h-4 w-4 appearance-none border border-border-default rounded-full bg-[var(--bg-input)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pt-forest dark:focus-visible:ring-pt-cream focus-visible:ring-offset-1 checked:border-pt-forest disabled:cursor-not-allowed transition-colors duration-[var(--motion-duration-fast)] ${className}`.trim()}
        {...rest}
      />
      <span
        className="absolute left-1 top-1 h-2 w-2 rounded-full bg-pt-forest opacity-0 peer-checked:opacity-100 pointer-events-none"
        aria-hidden
      />
    </span>
    <span className={labelClassName}>{label}</span>
  </label>
);

export default Radio;
